/**
 * Format date string to locale-specific date-time format
 *
 * @param dateString - ISO date string
 * @param language - Language code (e.g., 'hu', 'en')
 * @returns Formatted date-time string or "-" if invalid
 *
 * @example
 * formatDateTime('2026-03-12T11:22:05Z', 'hu') // "2026. 03. 12. 11:22:05"
 * formatDateTime('2026-03-12T11:22:05Z', 'en') // "3/12/2026, 11:22:05 AM"
 */
export const formatDateTime = (dateString: string, language: string): string => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";
  return date.toLocaleString(language);
};
